import { SET_ACTIVE_PRODUCER, SET_PRESIGNED_BILLING_LOGO } from './constants';

const initialState = {
    presignedBillingLogo: null,
    activeProducer: null,
};

function participantReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PRESIGNED_BILLING_LOGO: {
            return {
                ...state,
                presignedBillingLogo: action.presignedBillingLogo,
            };
        }

        default:
            return state;
        case SET_ACTIVE_PRODUCER: {
            return {
                ...state,
                activeProducer: action.producerId,
            };
        }
    }
}

export default participantReducer;
